import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SpinnerService } from '../../../services/spinner.service';
import { CategoryService } from '../../../services/category.service';
import { StmtService } from '../../../services/stmt.service';
import { TransferService } from '../../../services/transfer.service';
import { RecurrentService } from '../../../services/recurrent.service';

@Component({
    selector: 'app-statement-view',
    templateUrl: './statement-view.component.html',
    styleUrls: ['./statement-view.component.css']
})
export class StatementViewComponent implements OnInit {

    stmtId: number;
    stmt: any = {
        begin: null,
        end: null,
        month: null,
        in: 0,
        wait_in: 0,
        out: 0,
        wait_out: 0
    }
    action: string = 'add_uniq';
    amount_multiplier: number = 1;
    new_transfer: any = {
        date: new Date().toISOString().slice(0, 10),
        amount: 0,
        name: '',
        comment: '',
        category: null,
        recurrent: null,
        done: false,
    };
    transfers: any[] = [];
    categories: any[] = [];
    recurrents: any[] = [];

    constructor(private route: ActivatedRoute,
        private router: Router,
        private spinner: SpinnerService,
        private categoryService: CategoryService,
        private stmtService: StmtService,
        private transferService: TransferService,
        private recurrentService: RecurrentService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.stmtId = +params['id'];
            this.getStatement();
            this.getTransfers();
            this.getCategories();
            this.getRecurrents();
        });
    }
    
    getStatement() {
        this.spinner.startLoad('statement-view-getStatement');
        this.stmtService.getStatement(this.stmtId).subscribe(
            (stmt) => this.stmt = stmt,
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-getStatement')
        );
    }

    deleteStatement() {
        this.spinner.startLoad('statement-view-getStatement');
        this.stmtService.deleteStatement(this.stmtId).subscribe(
            (stmt) => this.router.navigate(['/statement']),
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-getStatement')
        );
    }

    getTransfers() {
        const params = {
            stmt: this.stmtId
        }
        this.spinner.startLoad('statement-view-getTransfers');
        this.transferService.getTransfers(params).subscribe(
            (transfers) => this.transfers = transfers,
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-getTransfers')
        );
    }

    getCategories() {
        this.spinner.startLoad('statement-view-getCategories');
        this.categoryService.getCategories().subscribe(
            (res) => this.categories = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-getCategories')
        );
    }

    getRecurrents() {
        this.spinner.startLoad('statement-view-getRecurrents');
        this.recurrentService.getRecurrents().subscribe(
            (res) => this.recurrents = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-getRecurrents')
        );
    }

    createTransfer() {
        this.new_transfer.amount = this.new_transfer.amount * this.amount_multiplier;
        this.new_transfer.stmt = this.stmtId;
        this.spinner.startLoad('statement-view-createTransfer');
        this.transferService.createTransfer(this.new_transfer).subscribe(
            (res) => this.postCreateTransfer(),
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-view-createTransfer')
        );
    }

    postCreateTransfer() {
        this.getStatement();
        this.getTransfers();
        this.new_transfer = {
            date: new Date().toISOString().slice(0, 10),
            amount: 0,
            name: '',
            comment: '',
            category: null,
            recurrent: null,
            done: false,
        };
    }
}
